import {createI18n, detectLocale} from '@soopkr-fe/soop-i18n';

const getLoadScriptPromise = (path: string) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = path;
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
};

// SoopI18n 코어 모듈을 동적으로 로드하고 i18nInstance 생성
const i18nInstance = createI18n({
  namespaces: ['player/vodEditor'],
});

// 비동기로 네임스페이스 로드 + 큐 플러시
async function loadNamespace() {
  const publicPath = `${STATIC_AFREECATV}/asset/app/soop-i18n/dist/ns/player/vodEditor/`;
  let nsPath = `${publicPath}vodEditor.ko_KR.js`;

  let locale = 'ko_KR';
  try {
    locale = detectLocale();
  } catch (error) {
    console.warn('Failed to detect locale, fallback to ko_KR:', error);
  }

  try {
    if (locale === 'en_US') {
      nsPath = `${publicPath}vodEditor.en_US.js`;
    } else if (locale === 'th_TH') {
      nsPath = `${publicPath}vodEditor.th_TH.js`;
    } else if (locale === 'zh_CN') {
      nsPath = `${publicPath}vodEditor.zh_CN.js`;
    } else if (locale === 'zh_TW') {
      nsPath = `${publicPath}vodEditor.zh_TW.js`;
    }

    await getLoadScriptPromise(nsPath);

    // 큐 플러시
    const count = i18nInstance.flushQueue();
    // eslint-disable-next-line no-console
    console.log(`${count} namespace(s) loaded`);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to load i18n namespace:', error);
  }
}

// 백그라운드에서 네임스페이스 로드
export const i18nReady = loadNamespace();

// 메서드 직접 export
export const t = (key: string, options?: any) => i18nInstance.t(key, options);

export const getLocale = () => i18nInstance.getLocale();

export default i18nReady;
